module.exports = __webpack_public_path__ + "img/fastcharger-definitive-semipublic.954b7c86.png";